export enum PortalStorageKey {
  /**
   * Entry that saves the locally saved tenantId with which the user was lastly authenticated.
   * There is no guarantee that the user is still authenticated with this tenant.
   * It is cleared right after app-initialization for authentication reasons but necessary later on for tenant-cross checks related to tracking.
   * details: https://celum.atlassian.net/browse/SPOR-789
   */
  LAST_TENANT_ID = 'por_previousTenantId'
}
